import { RouteRedirect } from 'modules/routing-module';
import { FC } from 'react';

export const EditorDraft: FC = () => <RouteRedirect routeKey="EditorCreate" />;
